import { AboutCards } from "../components/AboutUs/AboutCards";
import { Awards } from "../components/AboutUs/Awards";
import { Hero } from "../components/AboutUs/Hero";
import { Impression } from "../components/AboutUs/Impression";
import { Service } from "../components/AboutUs/Service";
import { Tagline } from "../components/AboutUs/Tagline";
import { WeDo } from "../components/AboutUs/WeDo";
import Client from "../components/Client/Client";

export const AboutUs = () => {
  return (
    <div style={{ perspective: "4000px"}} className="flex flex-col gap-8 relative">
      <Hero />
      <Tagline />
      <AboutCards />
      <Service />
      <WeDo />
      <Impression />
      <Awards />
      <Client />
      <div className=" mb-20 "></div>
    </div>
  );
};
